import { render, staticRenderFns } from "./mail-modal.vue?vue&type=template&id=5417f308&scoped=true&"
import script from "./mail-modal.vue?vue&type=script&lang=js&"
export * from "./mail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417f308",
  null
  
)

export default component.exports